import { certify } from '../lib/api.js';
import { certShareUrl } from '../lib/url.js';
import { shareLink } from '../lib/share.js';

export function mountCertifyFriend(host, { referrerId }) {
  host.innerHTML = `
    <div class="friend-form" data-test="certify-friend-form">
      <div class="friend-title">Who's next?</div>
      <input class="forensic-input friend-input" data-test="friend-name" placeholder="Friend's name" maxlength="80" />
      <button class="btn btn-rainbow" data-test="friend-generate" disabled>Generate Certified Link</button>
    </div>
  `;
  const input = host.querySelector('[data-test=friend-name]');
  const btn = host.querySelector('[data-test=friend-generate]');
  input.addEventListener('input', () => { btn.disabled = !input.value.trim(); });

  btn.addEventListener('click', async () => {
    btn.disabled = true; btn.textContent = 'Generating…';
    try {
      const { id, slug } = await certify({ name: input.value.trim(), referrerId });
      const url = certShareUrl(window.location.origin, { id, slug });
      host.querySelector('.friend-form').innerHTML = `
        <div class="friend-title">Send to ${escapeHtml(input.value.trim())}</div>
        <div class="friend-link" data-test="friend-link">${escapeHtml(url)}</div>
        <div class="friend-actions">
          <button class="btn btn-dark" data-test="friend-copy">📋 Copy</button>
          <button class="btn btn-rainbow" data-test="friend-share">📤 Share</button>
        </div>
        <div class="friend-toast" data-test="friend-toast" hidden></div>
      `;
      const toast = host.querySelector('[data-test=friend-toast]');
      const showToast = (msg) => {
        toast.textContent = msg; toast.hidden = false;
        setTimeout(() => { toast.hidden = true; }, 2000);
      };
      host.querySelector('[data-test=friend-copy]').addEventListener('click', async () => {
        await navigator.clipboard.writeText(url); showToast('Copied!');
      });
      host.querySelector('[data-test=friend-share]').addEventListener('click', async () => {
        const result = await shareLink({ url, title: 'Gay Certification', text: 'You\'ve been summoned for investigation.' });
        if (result === 'copied') showToast('Copied!');
      });
    } catch (err) {
      btn.disabled = false; btn.textContent = 'Generate Certified Link';
    }
  });
}

function escapeHtml(s) {
  return s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
}
